
import request from "@/utils/request";
const index = {
  // 列表（POST 须用 data，嵌套 search 才能传到 Laravel；params 挂在 URL 上无法正确序列化对象）
  list(query) {
    return request({
      url: "/jiejiOrder/list",
      method: "post",
      data: query
    });
  },
  // 详情
  detail(query) {
    return request({
      url: "/jiejiOrder/detail",
      method: "post",
      data: query
    });
  },
  detailBase(query) {
    return request({
      url: "/jiejiOrder/detailBase",
      method: "post",
      data: query
    });
  },
  detailTw(query) {
    return request({
      url: "/jiejiOrder/detailTw",
      method: "post",
      data: query
    });
  },
  // 编辑
  edit(data) {
    return request({
      url: "/jiejiOrder/editStatus",
      method: "post",
      data
    });
  },
  // 删除
  remove(data) {
    return request({
      url: "/jiejiOrder/remove",
      method: "post",
      data
    });
  },
  // 状态
  status(data) {
    return request({
      url: "/jiejiOrder/editStatus",
      method: "post",
      data
    });
  },
  // 排序
  sort(data) {
    return request({
      url: "/jiejiOrder/sort",
      method: "post",
      data
    });
  },
  // 新增
  create(data) {
    return request({
      url: "/jiejiOrder/create",
      method: "post",
      data
    });
  },
};
export default index;